export class AgentChatAudioCache {
  constructor() {
    this.audioByMessageId = new Map();
    this.requestsByMessageId = new Map();
  }

  get(messageId) {
    return this.audioByMessageId.get(messageId);
  }

  getOrCreate(messageId, loader) {
    const cachedAudio = this.get(messageId);
    if (cachedAudio) {
      return Promise.resolve(cachedAudio);
    }

    const pendingRequest = this.requestsByMessageId.get(messageId);
    if (pendingRequest) {
      return pendingRequest;
    }

    let loadedAudio;
    try {
      loadedAudio = loader();
    } catch (error) {
      return Promise.reject(error);
    }

    const request = Promise.resolve(loadedAudio)
      .then(audio => {
        this.audioByMessageId.set(messageId, audio);
        return audio;
      })
      .finally(() => {
        this.requestsByMessageId.delete(messageId);
      });

    this.requestsByMessageId.set(messageId, request);
    return request;
  }
}
